module.exports = __webpack_public_path__ + "img/tray_teeth_2020_11_03.6ecf85a9.jpg";